import React from 'react';
import { useTranslation } from 'react-i18next';
import { CloseSquare } from 'iconsax-react';

interface DeleteSellerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export default function DeleteSellerModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: DeleteSellerModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
      data-testid="delete-seller-modal-overlay"
      onClick={isLoading ? undefined : onClose}
    >
      <div 
        className="bg-white dark:bg-dark-surface rounded-[12px] p-[20px] max-w-[715px] w-full flex flex-col items-center gap-[20px] shadow-xl border border-gray-100 dark:border-gray-800 mx-4"
        data-testid="delete-seller-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div 
          className="w-[44px] h-[44px] bg-[#FAF2F3] dark:bg-red-950/20 rounded-[12px] flex items-center justify-center shrink-0"
          data-testid="delete-seller-modal-icon-container"
        >
          <CloseSquare size="20" className="text-[#CC2936]" variant="Linear" />
        </div>

        <div className="flex flex-col items-center gap-2" data-testid="delete-seller-modal-text-group">
          <h2 
            className="text-[24px] font-bold text-[#090909] dark:text-white leading-tight tracking-tight text-center max-w-[465px]"
            data-testid="delete-seller-modal-title"
            style={{ fontFamily: "'Open Sans', sans-serif" }}
          >
            {t('sellers.sellerProfile.details.deleteConfirmTitle')}
          </h2>

          <p 
            className="text-[14px] text-[#777777] dark:text-gray-400 leading-normal text-center max-w-[480px]"
            data-testid="delete-seller-modal-description"
            style={{ fontFamily: "'Open Sans', sans-serif" }}
          >
            {t('sellers.sellerProfile.details.deleteConfirmDesc')}
          </p>
        </div>

        <div 
          className="flex flex-wrap items-center justify-end gap-2 w-full mt-2"
          data-testid="delete-seller-modal-actions"
        >
          <button 
            className="w-[113px] h-[46px] rounded-[12px] border border-[#090909] dark:border-gray-600 font-semibold text-[#090909] dark:text-gray-300 bg-white dark:bg-transparent hover:bg-gray-50 dark:hover:bg-gray-800 transition-all text-sm flex items-center justify-center focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={onClose}
            disabled={isLoading}
            data-testid="delete-seller-modal-cancel-btn"
          >
            {t('cancel')}
          </button>
          <button 
            className="w-[181px] h-[46px] rounded-[12px] bg-[#CC2936] hover:bg-[#B0222E] font-semibold text-white transition-all text-sm flex items-center justify-center focus:outline-none shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={onConfirm}
            disabled={isLoading}
            data-testid="delete-seller-modal-confirm-btn"
          >
            {t('delete')}
          </button>
        </div>
      </div>
    </div>
  );
}
